import { getRootClassName } from '@lumx/core/js/utils/className';

/**
 * Component display name.
 */
export const COMPONENT_NAME = 'DatePicker';

/**
 * Component default class name and class prefix.
 */
export const CLASSNAME = getRootClassName(COMPONENT_NAME);
